/* eslint no-param-reassign: "error" */
import React, {
  useCallback,
} from 'react';
import {
  getStatus,
} from 'redux-resource';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import i18n from 'i18next';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';

import {
  EntityIcon,
} from 'web-components';

import {
  Flex,
  icons,
} from 'web-styled';

import * as S from './styled';

const LinkTo = {
  clients: 'users',
  programs: 'program_templates',
  workouts: 'workout_templates',
  exercises: 'exercises',
  documents: 'documents',
};

type Props = {
  tabName: string,
  searchQuery: string,
};

const SearchList = ({
  tabName,
  searchQuery,
}: Props) => {
  const mapState = useCallback(state => ({
    searchStatus: getStatus(
      state,
      'searchResults.requests.getSearchResults.status',
    ),
    searchedItems: coreSelectors.getSearchItems(
      tabName,
      searchQuery,
    )(state),
    addToLibrary: getUiState('addToLibrary')(state),
  }), [tabName, searchQuery]);

  const { searchedItems } = useSelector(mapState, shallowEqual);
  const getItemLink = (searchedItem) => (
    searchedItem.entityType === 'clients'
      ? `/${LinkTo[searchedItem.entityType]}/${searchedItem.id}/programs`
      : `/${LinkTo[searchedItem.entityType]}/${searchedItem.id}`
  );
  const getEmptyIcon = () => (tabName === 'clients' ? icons.allEmpty : icons[`${tabName}Empty`]);
  const getEmptyType = () => (tabName === 'clients' ? i18n.t('client_plural') : (
    tabName === 'all' ? 'results' : `$t(${tabName})`
  ));

  return (
    <Flex fillSpace column>
      {searchedItems.length > 0 ? (searchedItems.map(searchedItem => (
        <S.Item
          key={searchedItem.id}
        >
          <Flex
            spacing={10}
            fillSpace
            align="center"
            justify="space-between"
          >
            <Flex
              spacing={10}
              align="center"
              justify="center"
            >
              <Flex
                width="18px"
                height="20px"
                align="center"
                justify="center"
              >
                <EntityIcon
                  resourceType={searchedItem.entityType}
                />
              </Flex>
              <S.Name
                to={getItemLink(searchedItem)}
              >
                {searchedItem.name}
              </S.Name>
              {searchedItem.entityType === 'exercises' && (
                <S.PlayIcon />
              )}
            </Flex>
            <Flex
              justify="space-between"
              align="center"
              width="40%"
            >
              {searchedItem.entityType === 'clients' ? (
                <S.Author
                  to={getItemLink(searchedItem)}
                >
                  Client
                </S.Author>
              ) : (
                <S.Author
                  to={`/users/${searchedItem.author_id}`}
                >
                  {searchedItem.author_full_name || 'Gym Cloud'}
                </S.Author>
              )}
            </Flex>
          </Flex>
        </S.Item>
      ))) : (
        <S.Empty>
          <S.EmptyIcon
            src={getEmptyIcon()}
            alt=""
          />
          <span>
            {i18n.t('no_found', { type: getEmptyType() })}
          </span>
        </S.Empty>
      )}
    </Flex>
  );
};

export default SearchList;
